export default "__VITE_ASSET__CWYcnCbb__"